import {
  AiGetExperienceAnalysisDataRequestBodyType,
  AiGetExperienceAnalysisDataResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

export const getExperienceAnalysisData = async (
  data: ApiRequest<AiGetExperienceAnalysisDataRequestBodyType, any, any>
) => {
  const resp = await api.post<AiGetExperienceAnalysisDataResponseBodyType>(
    `/v2/ai/prompts/experience-analysis-data`,
    data.body
  );
  return resp.data;
};

export const useExperienceAnalysisData = () => {
  return useMutation<
    AiGetExperienceAnalysisDataResponseBodyType,
    Error,
    ApiRequest<AiGetExperienceAnalysisDataRequestBodyType, any, any>,
    any
  >({
    mutationFn: async (data) => getExperienceAnalysisData(data),
  });
};
